<template>
  <div
    v-if="title || imageUrl"
    v-lazy:background-image="imageUrl"
    class="header-container d-flex"
    :class="contentStyle"
    :style="height ? `--header-color: ${titleColor};` : ''"
  >
    <div class="title w-50 w-xl-100" :class="contentStyle">
      <prismic-rich-text v-if="title" :field="title" :style="titleStyle"></prismic-rich-text>
      <prismic-rich-text
        v-if="subtitle"
        class="subtitle mt-3"
        :style="titleStyle"
        :field="subtitle"
      ></prismic-rich-text>
      <div v-if="buttonText && buttonPath" class="w-100 mt-2 mt-xl-5 d-flex" :class="contentStyle">
        <Button
          :to="path"
          :blank="blank"
          :with-gradient="!!buttonBackground"
          :gradient="buttonBackground"
          :font-color="buttonTextColor"
          @click="showModal"
        >
          {{ buttonText }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'UI/Button';
import { mapGetters } from 'vuex';

export default {
  components: {
    Button
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonBlank: false,
      buttonPath: '',
      buttonText: '',
      buttonBackground: '',
      buttonTextColor: '',
      contentAlign: '',
      imageAlt: '',
      imageUrl: '',
      openModal: false,
      subtitle: '',
      title: '',
      titleColor: ''
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperienceColor']),
    blank() {
      return !this.openModal ? this.buttonBlank : false;
    },
    contentStyle() {
      let contentClasses = '';

      if (this.contentAlign === 'left') {
        contentClasses = 'text-left align-items-center justify-content-start';
      } else if (this.contentAlign === 'right') {
        contentClasses = 'text-right align-items-center justify-content-end';
      } else {
        contentClasses = 'text-center align-items-center justify-content-center';
      }

      return contentClasses;
    },
    path() {
      return !this.openModal ? this.buttonPath : '';
    },
    titleStyle() {
      return { color: this.titleColor };
    }
  },
  created() {
    const { primary } = this.slice;

    this.buttonBlank = primary.button_blank;
    this.buttonPath = primary.button_path[0]?.text;
    this.buttonText = primary.button_text[0]?.text;
    this.contentAlign = primary.content_align ? primary.content_align : '';
    this.imageAlt = primary.image.alt;
    this.imageUrl = primary.image.url;
    this.openModal = primary.open_modal;
    this.subtitle = primary.subtitle;
    this.title = primary.title1[0]?.text ? primary.title1 : '';
    this.titleColor = primary.title_color ? primary.title_color : 'black';
    this.buttonBackground = primary.button_background_color
      ? primary.button_background_color
      : this.getExperienceColor;
    this.buttonTextColor = primary.button_text_color ? primary.button_text_color : '#fff';
  },
  methods: {
    showModal() {
      if (this.openModal) {
        this.$bvModal.show(this.buttonPath);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  position: relative;
  overflow: hidden;
  height: 350px;
  border-radius: 5px;
  padding: 0px;
  background-size: cover;
  background-position: center;
  @include xl {
    height: auto;
    width: auto;
  }
}
.title {
  z-index: 1;
  padding: 30px;
  @include lg {
    padding: 10px;
  }
}
.w-lg-auto {
  @include lg {
    width: auto !important;
  }
}
.w-xl-100 {
  @include xl {
    width: 100% !important;
  }
}
</style>
<style lang="scss">
.header-container {
  .subtitle {
    a {
      text-decoration: underline;
      color: var(--header-color);
      text-underline-position: under;
      &:hover {
        opacity: 0.6;
      }
    }
  }
}
</style>
